const parseVersion = (value: string): number[] | null => {
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  const parts = value.split('.').map((segment) => Number.parseInt(segment, 10));
  if (parts.some((n) => Number.isNaN(n))) {
    return null;
  }
  return parts;
};

function compareAppVersions(a: string, b: string): -1 | 0 | 1 {
  const left = parseVersion(a);
  const right = parseVersion(b);
  if (!left || !right) {
    return 0;
  }
  const length = Math.max(left.length, right.length);
  for (let i = 0; i < length; i += 1) {
    const x = left[i] ?? 0;
    const y = right[i] ?? 0;
    if (x < y) return -1;
    if (x > y) return 1;
  }
  return 0;
}

export default compareAppVersions;
